export default __webpack_public_path__ + "static/media/settings.487c9268.svg";